import { render, staticRenderFns } from "./DragItem.vue?vue&type=template&id=4ac1608e&"
import script from "./DragItem.vue?vue&type=script&lang=ts&"
export * from "./DragItem.vue?vue&type=script&lang=ts&"
import style0 from "./DragItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports